goog.provide("shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg$default");
shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg$default = shadow.js.shim.module$src$svg$inform$lightbulb_fill_svg.default;
